module.exports = requirejs;


//////////////////
// WEBPACK FOOTER
// external "requirejs"
// module id = 23
// module chunks = 0